import type { PackageManager } from '@cli-types/core-engine/utils.js'
import type { DependencyPlanInput } from '@cli-types/next-adapter/runtime.js'
import { getDependencyPlan } from '@next-adapter/init/scaffolders/dependencies/get-dependency-plan.js'
import { installDependenciesAsync } from '@next-adapter/init/scaffolders/dependencies/install-dependencies-async.js'

export async function installDependencyDelta({
  cwd,
  pm,
  installableId,
  includeLinter,
  dependenciesInstalled,
  current,
  next
}: {
  cwd: string
  pm: PackageManager
  installableId: string
  includeLinter: boolean
  dependenciesInstalled: boolean
  current: DependencyPlanInput
  next: DependencyPlanInput
}): Promise<void> {
  const dependencyPlan = getDependencyPlan(next.presetIds, next.integrationIds, includeLinter)
  const currentPlan = getDependencyPlan(current.presetIds, current.integrationIds, includeLinter)

  const dependencyDiff = {
    dependencies: dependencyPlan.dependencies.filter(
      (dependency) => !currentPlan.dependencies.includes(dependency)
    ),
    devDependencies: dependencyPlan.devDependencies.filter(
      (dependency) => !currentPlan.devDependencies.includes(dependency)
    )
  }

  if (
    dependenciesInstalled ||
    (dependencyDiff.dependencies.length === 0 && dependencyDiff.devDependencies.length === 0)
  ) {
    return
  }

  const result = await installDependenciesAsync({
    cwd,
    pm,
    dependencies: dependencyDiff.dependencies,
    devDependencies: dependencyDiff.devDependencies
  })

  if (!result.success) {
    throw new Error(result.error ?? `Failed to install dependencies for ${installableId}.`)
  }
}
